import React from 'react';
import { MenuOptionsType } from './RecruiterCandidateCardFooter';
import { MenuItem, Popover, useMediaQuery } from '@mui/material';
import { Button } from 'flowbite-react';
import { IoChevronDown, IoChevronUp } from 'react-icons/io5';
import { Drawer } from '../shared/Drawer';
import { useThemeContext } from 'src/context/ThemeProvider';
import classNames from 'classnames';

const CandidateActionButton = ({
	handleCTAClick,
	disable,
	ctaText,
	openDrawer,
	setOpenDrawer,
	drawerHeader,
	drawerBody,
	menuOptions,
	hideActionButton = false,
}: {
	handleCTAClick: (e: React.MouseEvent<HTMLElement>, openMenu: (e: React.MouseEvent<HTMLElement>) => void) => void;
	disable?: boolean;
	ctaText: string;
	openDrawer: boolean;
	hideActionButton: boolean;
	setOpenDrawer: React.Dispatch<React.SetStateAction<boolean>>;
	drawerHeader: React.ReactElement;
	drawerBody: React.ReactElement;
	menuOptions: MenuOptionsType[];
}) => {
	const { themeMode } = useThemeContext();
	const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
	const open = Boolean(anchorEl);
	const id = open ? 'simple-popover' : undefined;
	const handleClick = (event: React.MouseEvent<HTMLElement>) => {
		setAnchorEl(event.currentTarget);
	};
	const handleClose = () => {
		setAnchorEl(null);
	};
	const isMobile = useMediaQuery('(max-width:960px)');

	return (
		<>
			{hideActionButton ? null : (
				<Button color="purplePlaced" disabled={disable} className="[&_span]:!p-0 !p-0 border-[#E5E7EB]">
					<p
						className="px-[10px] py-[8px]"
						onClick={e => {
							handleClose();
							handleCTAClick(e, handleClick);
						}}
					>
						{ctaText}
					</p>
					<span
						aria-haspopup="true"
						aria-describedby={id}
						aria-expanded={open ? 'true' : undefined}
						onClick={handleClick}
					>
						<IoChevronDown
							className={classNames('w-[34px] h-[34px] px-[8px] transition-transform', open ? 'rotate-[180deg]' : '')}
						/>
					</span>

					<Popover
						open={open}
						anchorEl={anchorEl}
						onClose={handleClose}
						anchorOrigin={{
							vertical: 'bottom',
							horizontal: 'right',
						}}
						transformOrigin={{
							vertical: 'top',
							horizontal: 'right',
						}}
						onClickCapture={() => {
							handleClose();
						}}
						sx={{
							'&>.MuiPaper-root': {
								borderRadius: '8px',
								background: themeMode === 'dark' ? '#18222D' : 'white',
								boxShadow: '0px 1px 2px -1px rgba(0, 0, 0, 0.10), 0px 1px 3px 0px rgba(0, 0, 0, 0.10)',
							},
							'&>.MuiPaper-root>.MuiButtonBase-root': {
								minHeight: '40px',
							},
						}}
					>
						{menuOptions &&
							menuOptions
								.filter(el => !el.hide)
								.map((menuOption: MenuOptionsType, index: number) => {
									return (
										<MenuItem key={index} className={'dark:!text-[#C7C9D9] dark:hover:!bg-[#2c3c50]'} {...menuOption}>
											{menuOption.label}
										</MenuItem>
									);
								})}
					</Popover>
				</Button>
			)}

			<Drawer
				maxHeight="90dvh"
				minHeight="max-content"
				boxShadow="0px -8px 32px 0px #00000040"
				isOpen={openDrawer}
				isModal={!isMobile}
				backgroundColor={themeMode === 'dark' ? '#18222D' : '#F7F9FB'}
				onClose={() => {
					setOpenDrawer(false);
				}}
				header={drawerHeader}
				body={drawerBody}
			/>
		</>
	);
};
export default CandidateActionButton;
